<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>修改密碼</p>
      </div>

      <el-form>
        <el-form-item label="用戶帳號 ：">
          <el-input :disabled="true" v-model="userName"> </el-input>
        </el-form-item>
        <el-form-item label="新密碼：">
          <el-input
            show-password
            v-model="newPassword"
            maxlength="18"
            @change="newPassword = newPassword.replace(/[^A-Za-z0-9]*$/g, '')"
            placeholder="請輸入新密碼"
          >
          </el-input>
          <p v-if="passwordTag" class="tips">*請輸入新密碼</p>
        </el-form-item>
        <el-form-item label="再次輸入新密碼：">
          <el-input
            show-password
            v-model="againPassword"
            maxlength="18"
            @change="
              againPassword = againPassword.replace(/[^A-Za-z0-9]*$/g, '')
            "
            placeholder="請再次輸入新密碼"
          >
          </el-input>

          <div>
            <p v-if="againPasswordTag" class="tips">*請確認新密碼</p>

            <p v-if="passwordIsSameTag" class="tips">*兩次密碼不一致</p>

            <p v-if="passwordLengthTag" class="tips">
              *請輸入6-18位密碼
            </p>
          </div>
        </el-form-item>
        <el-form-item label="驗證碼：">
          <el-input
            class="pinCodeInput"
            placeholder="請輸入6位數字驗證碼"
            v-model="PINcode"
          >
            <!-- <button @click="getCode()" class="PINcodeBtn" slot="append">{{getCodeText}}</button> -->
          </el-input>
          <button type="button" @click="getCode()" class="PINcodeBtn">
            {{ getCodeText }}
          </button>

          <p v-if="PINcodeTag" class="tips">*請輸入驗證碼</p>
        </el-form-item>
      </el-form>
      <div class="bottomBtn">
        <div class="btn" @click="saveAlert()">修改</div>
      </div>

      <DiaMess v-if="dialogVisible"></DiaMess>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "個人設置",
      navtitle: "修改密碼",
      userName: "", //帳號
      newPassword: "", //新密碼
      againPassword: "", //確認新密碼
      PINcode: "", //驗證碼
      dialogVisible: false,
      getCodeText: "獲取驗證碼",
      clickCode: true,
      seconds: 120,
      passwordTag: false,
      againPasswordTag: false,
      PINcodeTag: false,
      passwordLengthTag: false,
      passwordIsSameTag: false
    };
  },
  created() {
    this.userName = localStorage.getItem("role");
  },
  methods: {
    getCode() {
      let _this = this;

      if (!_this.clickCode) {
        return false;
      }
      _this.clickCode = false;
      _this.getCodeText = "重新獲取(120s)";
      _this
        .$get(
          `/request/member/verificationCode?email=${_this.userName}&type=resetPassword`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.dialogVisible = true;
            _this.$propMessage("驗證碼發送成功", "success", function() {
              _this.dialogVisible = false;
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
      let timer = setInterval(() => {
        _this.seconds = _this.seconds - 1;
        if (_this.seconds < 10) {
          _this.getCodeText = "重新獲取(0" + _this.seconds + "s)";
        } else {
          _this.getCodeText = "重新獲取(" + _this.seconds + "s)";
        }
        if (_this.seconds < 1) {
          _this.getCodeText = "獲取驗證碼";
          _this.seconds = 60;
          _this.clickCode = true;
          clearInterval(timer);
        }
      }, 1000);
    },

    // 保存修改
    saveAlert() {
      let _this = this;
      if (this.checkFormData()) {
        let param = {
          password: _this.againPassword,
          code: _this.PINcode
        };

        _this
          .$post(
            `/request/member/resetPassword`,
            param,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            if (res.code === "00000") {
              _this.dialogVisible = true;
              _this.$propMessage(
                "密碼重置成功，請重新登錄",
                "success",
                function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/login");
                }
              );
            } else {
              _this.dialogVisible = true;
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
              });
            }
          });
      }
    },

    // check form data
    checkFormData() {
      let _this = this;
      let flag = true;
      if (_this.newPassword.length < 6 || _this.newPassword.length > 18) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入6-18位密碼", "error", function() {
          _this.dialogVisible = false;
        });
        _this.passwordLengthTag = true;
        flag = false;
      } else {
        _this.passwordLengthTag = false;
        flag = true;
      }
      if (_this.newPassword === "") {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入新密碼", "error", function() {
          _this.dialogVisible = false;
        });
        _this.passwordTag = true;
        flag = false;
      } else {
        _this.passwordTag = false;
        flag = flag && true;
      }
      if (_this.newPassword !== _this.againPassword) {
        _this.dialogVisible = true;
        _this.$propMessage("兩次密碼輸入不一致", "error", function() {
          _this.dialogVisible = false;
        });
        _this.passwordIsSameTag = true;
        flag = false;
      } else {
        _this.passwordIsSameTag = false;
        flag = flag && true;
      }
      if (_this.PINcode === "") {
        _this.PINcodeTag = true;
        flag = false;
      } else {
        _this.PINcodeTag = false;
        flag = flag && true;
      }
      return flag;
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.el-input-group__append,
.PINcodeBtn {
  background: #6c3dea;
  color: #fff;
}

.tips {
  color: red;
  margin-left: 10px;
}

.el-form-item__content {
}

.el-form-item__content {
  // display: flex;
  .el-input--suffix {
    width: 4rem;
  }
}

.pinCodeInput {
  width: 75% !important;
}

.PINcodeBtn {
  height: 36px;
  width: 25%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/alterPasswords.vue